<svg
  [attr.width]="width"
  [attr.height]="height"
  [attr.viewBox]="'0 0 ' + width + ' ' + height" xmlns="http://www.w3.org/2000/svg">
  <g [attr.transform]="'translate(' + (+width / 2) + ', ' + (+height / 2) + ')'">
    <circle
      *ngFor="let dot of dots"
      [attr.cx]="dot.x"
      [attr.cy]="dot.y"
      [attr.r]="dotSize / 2"
      [attr.fill]="whiteColored ? 'white' : 'black'"
      [attr.opacity]="dot.opacity"
    />
  </g>
</svg>

